import { render, staticRenderFns } from "./suggestBox.vue?vue&type=template&id=7cf2120c&scoped=true"
import script from "./suggestBox.vue?vue&type=script&lang=js"
export * from "./suggestBox.vue?vue&type=script&lang=js"
import style0 from "./suggestBox.vue?vue&type=style&index=0&id=7cf2120c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf2120c",
  null
  
)

export default component.exports